export default function ViewBlockAudioRecord(props){
    return <div></div>
}